import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import Select from "react-select"

import { normalize, usePet } from '../../modules'

import Confirm from '../reusable/confirm'
import Modal from "../reusable/modal"

const Refund = ({ toggle, visible, order, onPerform, token }) => {
    const [selected, setSelected] = useState([])
    const [reason, setReason] = useState()
    const [cancel, setCancel] = useState(false)
    const [methods, setMethods] = useState([])

    usePet('paymentMethodNames', null, { notify: true, callback: ({ data }) => setMethods(data) })

    const onComplete = () => {
        toggle()
        onPerform()
    }

    const changeAmount = (i, val) => {
        let temp = [...selected]
        temp[i].amount = Number(val)
        setSelected(temp)
    }

    const changeRef = (i, val) => {
        let temp = [...selected]
        temp[i].ref = val
        setSelected(temp)
    }

    const [{ loading }, execute] = usePet('refundBill', {
        id: order?._id,
        cancel,
        reason,
        methods: selected.map(({ ref, value, amount }) => ({
            method: value, 
            amount
        }))
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Refunding bill...' }, token })

    const refund = (cncl = false) => {
        setCancel(cncl)
        Confirm({
            title: "Refund Bill",
            message: "Please confirm before refunding this bill",
            okText: "Refund Bill",
            onOk: execute
        })
    }

    return (
        <Modal
            w={ 700 }
            title={ `Refund Bill #${ order.orderNo < 1000 ? ('00000' + order.orderNo).slice(-4) : order.orderNo }` }
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap -mx-3 mb-3">
                <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Reason
                    </label>
                    <textarea
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-notes"
                        rows="4"
                        value={ reason }
                        onChange={ e => setReason(e.target.value)}
                        placeholder="Please indicate why you are refunding this bill." />
                </div>
            </div>
            <div className="flex mb-2 items-center flex-col">
                <Select
                    value={selected}
                    isMulti
                    styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                    onChange={setSelected}
                    options={methods.map(method => ({ label: method, value: method, amount: 0 }))}
                    placeholder="Select payment methods" />
            </div>
            <p className="font-semibold">Refunds</p>
            {
                selected?.length > 0 ?
                    <table className="table-auto w-full mt-3">
                        {/* Table header */}
                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                            <tr>
                                <th className="p-2">
                                    <div className="font-semibold text-center">No</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Method</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-center">Amount</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-center">Ref</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                            {
                                selected?.map((option, key) =>
                                    <tr>
                                        <td className="p-2">
                                            <div className="text-center">{key + 1}.</div>
                                        </td>
                                        <td className="p-2">
                                            <div className="">{option.label}</div>
                                        </td>
                                        <td className="p-2 text-center">
                                            <input onChange={ e => changeAmount(key, e.target.value) } placeholder="Amount" className="form-input w-24 text-center text-gray-500 hover:text-gray-600 font-medium focus:border-gray-300 active" type="text" style={{ outline: 'none' }} />
                                        </td>
                                        <td className="p-2 text-center">
                                            <input onChange={ e => changeRef(key, e.target.value) } placeholder="Codes / Description" className="form-input w-36 text-center text-gray-500 hover:text-gray-600 font-medium focus:border-gray-300 active" type="text" style={{ outline: 'none' }} />
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                    :
                    <div className="text-center my-5">
                        <h2>Please select a payment method above</h2>
                    </div>
            }
            <div className="flex flex-col items-end pr-3 py-3">
                <p className="font-semibold text-lg underline mb-2">Overview</p>
                <p className="mb-1">Amount Paid: Ksh. { normalize(order?.payments?.reduce((total, payment) => total + payment?.amount, 0)) }</p>
                <p className="mb-1">To Be Refunded: Ksh. { selected.reduce((total, method) => total + method.amount, 0) }</p>
                <p className="mb-1">Remainder: Ksh. { normalize(order?.payments?.reduce((total, payment) => total + payment?.amount, 0)) - selected.reduce((total, method) => total + method.amount, 0) }</p>
            </div>
            <div className="text-right">
                <button onClick={ toggle } className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg mr-4">Close</button>
                <button disabled={ loading } onClick={ () => refund(true) } className="text-white bg-yellow-500 mr-4 hover:bg-yellow-600 focus:ring-4 focus:ring-yellow-300 mt-2 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Refund & Cancel</button>
                <button disabled={ loading } onClick={ () => refund(false) } className="text-white hisani-btn-green-light mt-2 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Refund Bill</button>
            </div>
        </Modal>
    )
}

export default Refund